<template>
    <card>
      <template slot="header">
        <h3 class="card-title">Employee Details</h3>
      </template>
      <nav class="row">
        <ol class="breadcrumb arr-right bg-breadcrum">
          <li class="breadcrumb-item">
            <router-link to="/hr/dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link to="/hr/employeelist">Employees List</router-link>
          </li>
          <li class="breadcrumb-item active">Details</li>
        </ol>
      </nav>
      <hr style="margin-top:-10px"/>
      <form @submit.prevent="update_form">
        <div class="col-md-12">
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text">Employee ID:</p>
              <div class="col-md-1">
                <input type="text"  v-model='item.emp_id'  v-mask="['####-###']"  class="form-control" required>
              </div>
              <p  class="col-md-1 text-right p-text">Positions:</p>
              <div class="col-md-2">
                <select  v-model="item.position_id" class="form-control">
                  <option v-for="pos in positions" v-bind:value="pos.pos_id">{{pos.pos_name}}</option>
                </select>
              </div>
              <p  class="col-md-1 text-right p-text">Sub Dept:</p>
              <div class="col-md-2">
                <select  v-model="item.sub_department_id" class="form-control">
                  <option v-for="sub in subdepartment" v-bind:value="sub.id">{{sub.sub_department_name}}</option>
                </select>
              </div>
            </div>
          </div>
          <hr style="margin-top:10px"/>
          <div class="form-group">
            <div class="row">
              <div class="col-md-3">
                <h3 class="text-right"><u>Basic Info</u></h3>
              </div>
              <div class="col-md-4"></div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text">Fullname :</p>
              <div class="col-md-2">
                <input type="text"   pattern="[A-Za-z ]{1,32}" v-model="item.first_name" placeholder="Firstname" class="form-control" required>
                <small style="color:cornflowerblue"><i>Firstname</i></small>
              </div>
              <div class="col-md-2">
                <input type="text"  pattern="[A-Za-z ]{1,32}" v-model="item.last_name" class="form-control" placeholder="Lastname" required>
                <small style="color:cornflowerblue"><i>Lastname</i></small>
              </div>
              <div class="col-md-2">
                <input type="text"  pattern="[A-Za-z ]{1,32}" class="form-control" v-model="item.middle_name" placeholder="Middlename" required>
                <small style="color:cornflowerblue"><i>Middlename</i></small>
              </div>
              <div class="col-md-1">
                <select class="form-control" v-model="item.suffix">
                  <option value="">None</option>
                  <option value="Jr">Jr</option>
                  <option value="Sr">Sr</option>
                  <option value="I">I</option>
                  <option value="II">II</option>
                  <option value="III">III</option>
                  <option value="IV">IV</option>
                  <option value="IV">V</option>
                </select>
                <small style="color:cornflowerblue"><i>Suffix</i></small>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text">Current Address :</p>
              <div class="col-md-7">
                <input type="text"  v-model="item.current_address" class="form-control" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text"> Permanent address :</p>
              <div class="col-md-7">
                <input type="text"  v-model="item.permanent_address" class="form-control" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text"> Birth Date :</p>
              <div class="col-md-2">
                <input type="date" v-model="item.birthdate" class="form-control" required>
              </div>
            </div>
          </div>
          <hr style="margin-top:50px"/>
          <div class="form-group">
            <div class="row">
              <div class="col-md-3">
                <h3 class="text-right"><u>Contacts Info</u></h3>
              </div>
              <div class="col-md-6"></div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text">Contact No :</p>
              <div class="col-md-3">
                <input type="tel" v-mask="['####-#######']"  v-model="item.contact" class="form-control" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text">Emergency Contact :</p>
              <div class="col-md-3">
                <input type="tel" v-mask="['####-#######']"  v-model="item.emergency_no" class="form-control" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text">Contact Person :</p>
              <div class="col-md-3">
                <input type="text"  pattern="[A-Za-z ]{1,32}" v-model="item.contact_person" class="form-control" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text">Personal Email :</p>
              <div class="col-md-3">
                <input type="email"  class="form-control" v-model="item.email_address" required>
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="row">
              <p  class="col-md-2 text-right p-text">Relationship :</p>
              <div class="col-md-2">
                <select v-model="item.relationship" class="form-control"  required>
                  <option disabled value="">-- Please select one --</option>
                  <option value="Mother">Mother</option>
                  <option value="Father">Father</option>
                  <option value="Father">Daughter</option>
                  <option value="Son">Son</option>
                  <option value="Sister">Sister</option>
                  <option value="Brother">Brother</option>
                  <option value="Aunt">Aunt</option>
                  <option value="Uncle">Uncle</option>
                  <option value="Niece">Niece</option>
                  <option value="Nephew">Nephew</option>
                  <option value="Sibling">Sibling</option>
                  <option value="Sibling">Guardian</option>
                  <option value="Live in Partner">Live in Partner</option>
                  <option value="Cousin(Female)">Cousin(Female)</option>
                  <option value="Cousin(Male)">Cousin(Male)</option>
                  <option value="Grandmother">Grandmother</option>
                  <option value="Brother">Grandfather</option>
                  <option value="Granddaughter">Granddaughter</option>
                  <option value="Grandson">Grandson</option>
                  <option value="Stepsister">Stepsister</option>
                  <option value="Stepbrother">Stepbrother</option>
                  <option value="Stepmother">Stepmother</option>
                  <option value="Stepfather">Stepfather</option>
                  <option value="Girlfreind">Girlfreind</option>
                  <option value="Boyfreind">Boyfreind</option>
                  <option value="Wife">Wife</option>
                  <option value="Husband">Husband</option>
                </select>
              </div>
            </div>
          </div>
          <hr/>
          <!-- Experience TO DO HERE -->
          <div class="form-group">
            <div class="row">
              <div class="col-md-3">
                <h3 class="text-right"><u>Employee Experience</u></h3>
              </div>
              <div class="col-md-6"></div>
            </div>
          </div>
          <!-- START FORM HERE -->
          <div v-for="exp in item.experience">
            <hr style="margin-top:10px"/>
            <div class="form-group">
              <div class="row">
                <p  class="col-md-2 text-right p-text">Employeer :</p>
                <div class="col-md-7">
                  <input type="text"   v-model="exp.employeer" class="form-control" >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p  class="col-md-2 text-right p-text">Company Address :</p>
                <div class="col-md-7">
                  <input type="text"   v-model="exp.company_address" class="form-control" >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p  class="col-md-2 text-right p-text">Job Title/Position :</p>
                <div class="col-md-7">
                  <input type="text"   v-model="exp.job_title" class="form-control" >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p  class="col-md-2 text-right p-text">Start Date :</p>
                <div class="col-md-3">
                  <input type="date"   v-model="exp.start_date" class="form-control" >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p  class="col-md-2 text-right p-text">End Date :</p>
                <div class="col-md-3">
                  <input type="date"   v-model="exp.end_date" class="form-control" >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p  class="col-md-2 text-right p-text">Previous Salary :</p>
                <div class="col-md-2">
                  <input type="text"   v-model="exp.previous_salary" class="form-control" >
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="row">
                <p  class="col-md-2 text-right p-text">Reason for leaving :</p>
                <div class="col-md-7">
                  <input type="text"   v-model="exp.reason_for_leaving" class="form-control" >
                </div>
              </div>
            </div>
          </div>
          <!-- END OF FORM HERE -->
          <div class="form-group">
            <div class="row">
              <p  class="col-md-3 text-right p-text"></p>
              <div class="col-md-6">
                <div class="row">
                  <p  class="col-md-6 text-right p-text"></p>
                  <div class="col-sm-3">
                    <!-- <button class="btn btn-info"><i class="fa fa-save"></i>&nbsp;Employee list</button> -->
                    <router-link to="/hr/employeelist" class="btn btn-info"><i class="fa fa-list"></i>&nbsp;Employees List</router-link>
                  </div>
                  <div class="col-sm-3">
                    <button class="btn btn-info"><i class="fa fa-save"></i>&nbsp;Save Changes</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </card>
  </template>
<script>
  /* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card
  },
  data() {
    return {
      item: {},
      positions: [],
      subdepartment: [],
      experience: [{
        employeer: '',
        company_address: '',
        job_title: '',
        start_date: '',
        end_date: '',
        previous_salary: '',
        reason_for_leaving: ''
      }],

      result: {}
    }
  },
  mounted: function () {
    this.getEmployeeInfo()
    this.getPositionName()
    this.getDepartmentName()
  },
  methods: {

    saveProfile() {
      axios({
          method: 'get',
          url: '/user/1',
          data: {
            first_name: this.first_name,
            last_name: this.last_name
          }
        })
        .then(resp => {

        })
        .catch(error => {

        })
    },

    getEmployeeInfo() {
      axios.get('api/updateemployeeinfo/get/' + this.$route.params.id)
        .then(response => {
          this.item = response.data;
        })
        .catch(error => {
          console.log(error)
        });
    },
    getPositionName() {
      axios.get('api/positions')
        .then(response => {
          this.positions = response.data;
        })
        .catch(error => {
          console.log(error)
        });
    },
    getDepartmentName() {
      axios.get('api/subdepartments')
        .then(response => {
          this.subdepartment = response.data;
        })
        .catch(error => {
          console.log(error)
        });
    },

    update_form(e) {
      e.preventDefault();
      this.$swal({
          title: 'Are you sure?',
          text: 'Do you want to save changes.',
          type: 'warning',
          showCancelButton: true,
          showCloseButton: false,
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.post('api/updateemployeebyhr/update/' + this.item.employee_id, {
                //update employee table
                emp_id: this.item.emp_id,
                position_id: this.item.position_id,
                sub_department_id: this.item.sub_department_id,
                first_name: this.item.first_name,
                last_name: this.item.last_name,
                middle_name: this.item.middle_name,
                suffix: this.item.suffix,
                birthdate: this.item.birthdate,
                current_address: this.item.current_address,
                permanent_address: this.item.permanent_address,
                //update contact table
                contact: this.item.contact,
                contact_person: this.item.contact_person,
                emergency_no: this.item.emergency_no,
                email_address: this.item.email_address,
                relationship: this.item.relationship,
                //Update experience
                experience: this.item.experience
              })
              .then(response => {
                this.$swal({
                  type: 'success',
                  title: 'Save',
                  text: 'You successfully save changes',
                  showConfirmButton: false,
                  timer: 2000
                })

                this.$router.push({
                  name: 'employee-list'
                });
                console.log(response.data)
              })
              .catch(e => {
                console.log(e.response)
              })
          }
        });
    }
  },
 

}
</script>




// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-edit-info.vue